import { t } from '@avalara/bat-apps-shared/i18n';
import { SCol, SIcon, SRow } from '@avalara/skylab-sdk/react';
import styled from 'styled-components';

import type { Currency } from '../../../../../types/currency';
import { formatPrice } from '../../../../shared/helpers';

const InlineSpanContainer = styled.div`
  display: inline-flex;
  span {
    display: inline-flex;
    align-items: center;
    margin-left: 5px;
  }
`;

type Props = {
  currency?: Currency;
  discountAmount: number;
  discountName?: string | null;
  showDiscountedSubTotal?: boolean;
  subtotal: number;
};

const Discount = ({ currency, discountName, discountAmount, showDiscountedSubTotal, subtotal }: Props) => (
  <>
    <SRow className='margin-top-xs'>
      <SCol span='8' className='hide-overflow'>
        <span className='pad-right-sm'>{t('client.general.discount')}</span>
        {discountName && (
          <span className='no-wrap' title={discountName}>
            <SIcon name='tag' aria-hidden='true' className='pad-right-xs' />
            {discountName}
          </span>
        )}
      </SCol>
      <SCol span='4' className='text-right align-self-start'>
        <InlineSpanContainer>
          <span>
            - {discountAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </span>
        </InlineSpanContainer>
      </SCol>
    </SRow>
    {showDiscountedSubTotal && (
      <SRow>
        <SCol span='xl-10 lg-10 6' className='align-self-end'>
          {t('client.general.your-price')}
        </SCol>
        <SCol span='xl-2 lg-2 4' className='text-right'>
          <hr className='pad-bottom-sm' />
          <InlineSpanContainer>
            <span>{formatPrice(subtotal, 2, currency)}</span>
          </InlineSpanContainer>
        </SCol>
      </SRow>
    )}
  </>
);
export default Discount;
